import { ApolloCache } from 'apollo-cache';
import { Resolvers } from 'apollo-client';
import {
  GetGetStartedWizardStateDocument,
  GetSendAsStateDocument,
  GetTicketListSelectionStateDocument,
  GetTicketListStateDocument,
  GetUserSettingsDocument,
  IGetGetStartedWizardStateQuery,
  IGetStartedWizardState,
  IGetTicketListSelectionStateQuery,
  IQuery,
  ISendAsState,
  ITicketListSelectionState,
  ITicketListState,
  IUserSettings,
  Maybe
} from '../../generated/graphql';
import {
  defaultClientState,
  defaultGetStartedWizardState
} from './default-client-state';

// TODO: Better way to separate these, and not have one giant client resolve file? (i.e. some ResolverRegistry)
export const clientResolvers: Resolvers = {
  Query: {
    getGetStartedWizardState: (
      _parent: unknown,
      _variables: {},
      { cache }: { cache: ApolloCache<IQuery> }
    ): Maybe<IGetStartedWizardState> => {
      try {
        const wizardState: {
          getGetStartedWizardState: IGetStartedWizardState;
        } | null = cache.read<{
          getGetStartedWizardState: IGetStartedWizardState;
        }>({
          query: GetGetStartedWizardStateDocument,
          optimistic: false
        });

        return wizardState!.getGetStartedWizardState;
      } catch (e) {
        console.error('Error happened during get wizard state: ' + e);
        return defaultGetStartedWizardState.getGetStartedWizardState!;
      }
    },
    ticketListState: (
      _parent: unknown,
      _variables: unknown,
      { cache }: { cache: ApolloCache<IQuery> }
    ): Maybe<ITicketListState> => {
      const ticketListState: {
        ticketListState: ITicketListState;
      } | null = cache.readQuery<{
        ticketListState: ITicketListState;
      }>({ query: GetTicketListStateDocument });

      if (!ticketListState) {
        return defaultClientState.ticketListState!;
      }
      return ticketListState.ticketListState;
    },
    ticketListSelectionState: (
      _parent: unknown,
      _variables: unknown,
      { cache }: { cache: ApolloCache<IQuery> }
    ): Maybe<ITicketListSelectionState> => {
      const ticketListSelectionState = cache.readQuery<
        IGetTicketListSelectionStateQuery
      >({ query: GetTicketListSelectionStateDocument });

      if (!ticketListSelectionState) {
        return defaultClientState.ticketListSelectionState!;
      }
      return ticketListSelectionState.ticketListSelectionState;
    },
    userSettings: (
      _parent: unknown,
      _variables: unknown,
      { cache }: { cache: ApolloCache<IQuery> }
    ): Maybe<IUserSettings> => {
      const userSettings: {
        userSettings: IUserSettings;
      } | null = cache.readQuery<{
        userSettings: IUserSettings;
      }>({ query: GetUserSettingsDocument });

      if (!userSettings) {
        return defaultClientState.userSettings!;
      }
      return userSettings.userSettings;
    },
    sendAsState: (
      _parent: unknown,
      _variables: unknown,
      { cache }: { cache: ApolloCache<IQuery> }
    ): Maybe<ISendAsState> => {
      const sendAsState: {
        sendAsState: ISendAsState;
      } | null = cache.readQuery<{
        sendAsState: ISendAsState;
      }>({ query: GetSendAsStateDocument });

      if (!sendAsState) {
        return defaultClientState.sendAsState!;
      }
      return sendAsState.sendAsState;
    }
  },
  Mutation: {
    setGetStartedWizardState: (
      _parent: unknown,
      { wizardState }: { wizardState: IGetStartedWizardState },
      { cache }: { cache: ApolloCache<IQuery> }
    ) => {
      cache.writeData<IGetGetStartedWizardStateQuery>({
        data: {
          getGetStartedWizardState: wizardState as IGetGetStartedWizardStateQuery['getGetStartedWizardState']
        }
      });
      return wizardState;
    },
    setTicketListState: (
      _parent: unknown,
      { state }: { state: ITicketListState },
      { cache }: { cache: ApolloCache<IQuery> }
    ) => {
      cache.writeData({
        data: {
          ticketListState: {
            ...state
          }
        }
      });

      return state;
    },
    setTicketListSelectionState: (
      _parent: unknown,
      { state }: { state: ITicketListSelectionState },
      { cache }: { cache: ApolloCache<IQuery> }
    ) => {
      cache.writeData({
        data: {
          ticketListSelectionState: {
            ...state,
            __typename: 'TicketListSelectionState'
          }
        }
      });

      return state;
    },
    setUserSettings: (
      _parent: unknown,
      { userSettings }: { userSettings: IUserSettings },
      { cache }: { cache: ApolloCache<IQuery> }
    ) => {
      cache.writeData({
        data: {
          userSettings: {
            ...userSettings,
            __typename: 'UserSettings'
          }
        }
      });

      return userSettings;
    },
    setSendAsState: (
      _parent: unknown,
      { sendAsState }: { sendAsState: ISendAsState },
      { cache }: { cache: ApolloCache<IQuery> }
    ) => {
      cache.writeData({
        data: {
          sendAsState: {
            ...sendAsState,
            __typename: 'SendAsState'
          }
        }
      });

      return sendAsState;
    }
  }
};
